// refundInitiationListSlice.js
import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../apiSlice";

const refundInitiationListAdapter = createEntityAdapter({
  selectId: (refundInitiation) => refundInitiation.id,
});

const initialState = refundInitiationListAdapter.getInitialState();

export const refundInitiationListSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRefundInitiationList: builder.query({
      query: (filters = {}) => {
        const params = [];
        if (filters.status) params.push(`status=${filters.status}`);
        if (filters.search)
          params.push(`search=${encodeURIComponent(filters.search)}`);

        return params.length
          ? `refund_payments?${params.join("&")}`
          : "refund_payments";
      },

      transformResponse: (responseData) => {
        const loadedRefundInitiations = responseData.data.map((r) => ({
          ...r,
        }));
        return refundInitiationListAdapter.setAll(
          initialState,
          loadedRefundInitiations
        );
      },

      providesTags: (result) =>
        result
          ? [
              { type: "refundInitiation", id: "LIST" },
              ...result.ids.map((id) => ({ type: "refundInitiation", id })),
            ]
          : [{ type: "refundInitiation", id: "LIST" }],
    }),

    getRefundInitiationById: builder.query({
      query: (refundId) => `refund_payments/${refundId}`,
      transformResponse: (responseData) => responseData.data,
      providesTags: (result, error, refundId) => [
        { type: "refundInitiation", id: refundId },
      ],
    }),
  }),
});
export const {
  useGetRefundInitiationListQuery,
  useGetRefundInitiationByIdQuery,
} = refundInitiationListSlice;
const refundInitiationFilter = (state) => state.refundInitiationFilter;
const selectRefundInitiationListResult = createSelector(
  [refundInitiationFilter, (state) => state],
  (filter, state) =>
    refundInitiationListSlice.endpoints.getRefundInitiationList.select({
      status: filter.status,
      search: filter.search,
    })(state)
);
const selectRefundInitiationListData = createSelector(
  [selectRefundInitiationListResult],
  (result) => result?.data ?? initialState
);
export const {
  selectAll: selectRefundInitiations,
  selectById: selectRefundInitiationById,
  selectIds: selectRefundInitiationIds,
} = refundInitiationListAdapter.getSelectors((state) =>
  selectRefundInitiationListData(state)
);
